import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'mwo-switch-button',
  templateUrl: './switch-button.component.html',
  styleUrls: ['./switch-button.component.scss']
})
export class SwitchButtonComponent implements OnInit {
  @Input() translationKey = '';
  @Input() checked = false;

  constructor() { }

  ngOnInit() {
  }

}
